var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "wizard-section-page" },
    [
      _vm.loadingComponent === false
        ? [
            _c("WizardStep", {
              attrs: {
                wizardstep: _vm.content.wizardSteps[this.currentStep],
                wizardTitle: _vm.content.wizardTitle,
                settings: _vm.settings,
              },
            }),
            _c("WizardNavigation", {
              attrs: {
                currentStep: _vm.currentStep,
                totalSteps: _vm.totalSteps,
                title: _vm.matchTitle,
                linkText: _vm.content.titleLinkText,
                link: _vm.content.titleLinkUrl,
                lastStepText: _vm.content.lastStepButtonText,
                disableNextButton: _vm.nextButtonDisabled,
                disableNextStepReason: _vm.nextButtonDisabledReason,
                disabledBackButton: _vm.backButtonDisabled,
                wizardType: _vm.content.wizardType,
              },
              on: {
                next: function ($event) {
                  return _vm.next()
                },
                back: function ($event) {
                  return _vm.back()
                },
              },
            }),
          ]
        : [
            _c(
              "div",
              { staticClass: "top d-flex align-items-center flex-column mt-4" },
              [
                _c("b-skeleton", {
                  staticClass: "mt-4",
                  attrs: { width: "140px", height: "40px" },
                }),
                _c("b-skeleton", {
                  staticClass: "mt-4",
                  attrs: { width: "180px" },
                }),
                _c("b-skeleton", {
                  staticClass: "mt-4",
                  attrs: { width: "100px" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "content mt-4 d-flex justify-content-center" },
              [_c("b-skeleton", { attrs: { width: "100%", height: "100px" } })],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }